import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';

interface FetchCanUnlinkOrionConsumerParams {
  clientId: number;
}

const fetchCanUnlinkOrionConsumer = async ({
  clientId,
}: FetchCanUnlinkOrionConsumerParams): Promise<boolean> => {
  return authFetch(urlWithParams('/Consumer/ClientSettings/CanUnlinkOrionConsumer', { clientId }));
};

export const useCanUnlinkOrionConsumerQuery = () => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.canUnlinkOrionConsumer(clientId),

    () => fetchCanUnlinkOrionConsumer({ clientId }),
  );
};
